const unitOptions: SelectOption[] = [
    { label: "Unit", value: "unit" },
    { label: "Litre", value: "litre" },
    { label: "Dozen", value: "dozen" },
    { label: "Tonne", value: "tonne" },
    { label: "Gram", value: "gram" },
    { label: "Kilogram", value: "kilogram" },
    { label: "Millilitre", value: "millilitre" },
];
const gridUnitOptions: SelectOption[] = [
  { label: "U", value: "unit" },
  { label: "L", value: "litre" },
  { label: "Dz", value: "dozen" },
  { label: "T", value: "tonne" },
  { label: "g", value: "gram" },
  { label: "kg", value: "kilogram" },
  { label: "ml", value: "millilitre" },
];
const gridDiscountTypeOptions: SelectOption[] = [
  { value: "flat", label: "₹" },       
  { value: "percentage", label: "%" }
];
const uomOptions: SelectOption[] = [
    { label: "Centimeter (cm)", value: "cm" },
    { label: "Meter (m)", value: "m" },
];

const gstPercentageOptions: SelectOption[] = [
    { value: "0", label: "0%" },
    { value: "5", label: "5%" },
    { value: "8", label: "8%" },
    { value: "12", label: "12%" },
    { value: "18", label: "18%" },
    { value: "28", label: "28%" },
]

const deliveryTypeOptions = [
    { id: 1, name: "Hyper Local", key: "hyperlocal" },
    { id: 3, name: "Pan India", key: "panindia" },
];

const weightUOMOptions = [
    { label: "Kilogram (kg)", value: "kg" },
    { label: "Gram (g)", value: "gram" },
];

const discountTypeOptions: SelectOption[] = [
    { value: "flat", label: "Flat" },
    { value: "percentage", label: "Percentage (%)" }
]
const productDetailsDefaultValues: ProductFormValues = {
    store_id: 0,
    name: "",
    short_description: "",
    category_id: "",
    barcode: "",
    max_sale_quantity: null,
    original_price: null,
    price: null,
    discount_type: "",
    discount_value: "",
    gst_percentage: "",
    gst_price: null,
    uom: "",
    uom_value: null,
    long_description: "",
    have_variant: false,
    is_addon_item: false,
    brand: "",
    sequence: 1,
    stock_quantity: null,
    thumbnail_image: null,
    store_category_name: "",
    store_category_id: null,
    storeDeliveryType: null,
    tags: null,
    attributes: {},
    productAttributes: {},
    productCategoryAttributes: {},
    variantFormState: {
        productPriceDetails: {
            id: 0,
            price: 0,
            original_price: 0,
            stock_quantity: 0,
            barcode: "",
            image: "",
            name:"",
            discount_type:"flat",
            discount_value:"0",
            uom:"unit",
            uom_value:"0",
            gst_percentage:"0"
        },
        combinations: [],
        selectedAttributeIds: [],
        attributeVariantGroups: [],
        selectedVariantGroups: [],
        variantCombinations: [],
    }
};



const measurementAndPolicyDefaultValues: MeasurementAndPolicyValues = {
    shipment_buffer_window: "",
    is_cancellable: false,
    is_returnable: false,
    return_window: null,
    weight: null,
    weight_uom: "kg",
    dimension_uom: "cm",
    length: null,
    breadth: null,
    height: null,
    storeDeliveryType: null,
};



export {
    unitOptions,
    uomOptions,
    deliveryTypeOptions,
    productDetailsDefaultValues,
    gstPercentageOptions,
    discountTypeOptions,
    measurementAndPolicyDefaultValues,
    weightUOMOptions,
    gridUnitOptions,
    gridDiscountTypeOptions
}